import React from 'react';
import Link from 'next/link';
import { Box, ListItemIcon } from '@mui/material';

import { SubMenuItem } from '~/types/constants/menu';

import {
  ActiveSubmenuIndicator,
  InactiveSubmenuIndicator,
  StyledLastLevelButton,
  StyledSubmenuText,
} from '../elements';

interface SubItemMenuInsideProps {
  subItem: SubMenuItem;
  pathname: string;
  toggleSubmenu: (label: string) => void;
  open?: boolean;
}

export function SubItemMenuInside({
  subItem,
  pathname,
  toggleSubmenu,
  open = true,
}: SubItemMenuInsideProps) {
  const { href, label, disabled } = subItem;
  const isActive = pathname === href;

  return (
    <Box key={label} sx={{ marginLeft: 1 }}>
      <Link href={href} legacyBehavior key={label}>
        <StyledLastLevelButton
          className={isActive ? 'active' : ''}
          onClick={() => toggleSubmenu(label)}
          disabled={disabled}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
            {isActive ? (
              <ActiveSubmenuIndicator />
            ) : (
              <InactiveSubmenuIndicator />
            )}
            <StyledSubmenuText inset={false} isActive={isActive} open={open}>
              {label}
            </StyledSubmenuText>
          </Box>
          <ListItemIcon
            sx={{
              minWidth: 'inherit',
              color: 'currentcolor',
              textAlign: 'right',
            }}
          />
        </StyledLastLevelButton>
      </Link>
    </Box>
  );
}

export default SubItemMenuInside;
